import UpdateButton from './component';
import { UpdateButtonProps } from './types';

export default UpdateButton;
export type { UpdateButtonProps };
